import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, Output, ViewChild, output } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ICONS } from '../../../core/constants/commonConstants';
import { PlacementArray } from 'node_modules/@ng-bootstrap/ng-bootstrap/util/positioning';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule, NgbTooltip],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.css',
})
export class IconComponent {
  @ViewChild('el') el!: ElementRef;
  @Input() icon?: keyof typeof ICONS;
  @Input() color: string = '';
  @Input() fillColor: string = '';
  @Input() hoverClass: string = '';
  @Input() tooltip: string = '';
  @Input() tooltipPlacement?: PlacementArray;
  @Input() iconSize?: string;
  @Input() roundedIcon?: boolean = false;
  @Input() filledIcon?: boolean = false;
  @Input() disabled?: boolean = false;
  @Input() avoidContainerAsBody?: boolean = false;
  onIconClick = output();
  @Input() iconContainerStyle?: {
    [klass: string]: any;
  };

  getClass = () => {
    const obj: Record<string, boolean> = {};
    if (this.hoverClass) {
      obj[this.hoverClass] = true;
    }
    obj['cursor-pointer'] = !this.disabled;
    return obj;
  };

  getIcon = () => {
    if (this.icon) {
      return ICONS[this.icon as keyof typeof ICONS] || this.icon;
    }
    return '';
  };
}
